export default "__VITE_ASSET__CgcNwTGB__"